// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"UE-z","smallCardRow":"VE-z","largeCardRow":"WE-z","productSearchRow":"XE-z","curatedRow":"YE-z"};